/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { customElement } from 'common';

import K12HallpassStudentrestrictions from './components/k12-hallpass-studentrestrictions/k12-hallpass-studentrestrictions';
export * from './components/k12-hallpass-studentrestrictions/k12-hallpass-studentrestrictions';
export { K12HallpassStudentrestrictions };
customElement.register('k12-hallpass-studentrestrictions', 'sis', K12HallpassStudentrestrictions.defaultProps, K12HallpassStudentrestrictions);

import K12HallpassStuhallpasses from './components/k12-hallpass-stuhallpasses/k12-hallpass-stuhallpasses';
export * from './components/k12-hallpass-stuhallpasses/k12-hallpass-stuhallpasses';
export { K12HallpassStuhallpasses };
customElement.register('k12-hallpass-stuhallpasses', 'sis', K12HallpassStuhallpasses.defaultProps, K12HallpassStuhallpasses);

import K12HallpassStuhallpasssummary from './components/k12-hallpass-stuhallpasssummary/k12-hallpass-stuhallpasssummary';
export * from './components/k12-hallpass-stuhallpasssummary/k12-hallpass-stuhallpasssummary';
export { K12HallpassStuhallpasssummary };
customElement.register('k12-hallpass-stuhallpasssummary', 'sis', K12HallpassStuhallpasssummary.defaultProps, K12HallpassStuhallpasssummary);

import K12IncidentSummary from './components/k12-incident-summary/k12-incident-summary';
export * from './components/k12-incident-summary/k12-incident-summary';
export { K12IncidentSummary };
customElement.register('k12-incident-summary', 'sis', K12IncidentSummary.defaultProps, K12IncidentSummary);

import K12GradReqOverviewDetailHeader from './components/sis-k12-grad-req-overview-detail-header/sis-k12-grad-req-overview-detail-header';
export * from './components/sis-k12-grad-req-overview-detail-header/sis-k12-grad-req-overview-detail-header';
export { K12GradReqOverviewDetailHeader };
customElement.register('sis-k12-grad-req-overview-detail-header', 'sis', K12GradReqOverviewDetailHeader.defaultProps, K12GradReqOverviewDetailHeader);

import K12GradreqGradeLayout from './components/sis-k12-gradreq-grade-layout/sis-k12-gradreq-grade-layout';
export * from './components/sis-k12-gradreq-grade-layout/sis-k12-gradreq-grade-layout';
export { K12GradreqGradeLayout };
customElement.register('sis-k12-gradreq-grade-layout', 'sis', K12GradreqGradeLayout.defaultProps, K12GradreqGradeLayout);

import K12GradreqThreshold from './components/sis-k12-gradreq-threshold/sis-k12-gradreq-threshold';
export * from './components/sis-k12-gradreq-threshold/sis-k12-gradreq-threshold';
export { K12GradreqThreshold };
customElement.register('sis-k12-gradreq-threshold', 'sis', K12GradreqThreshold.defaultProps, K12GradreqThreshold);

import TwoPointSlider from './components/sis-two-point-slider/sis-two-point-slider';
export * from './components/sis-two-point-slider/sis-two-point-slider';
export { TwoPointSlider };
customElement.register('sis-two-point-slider', 'sis', TwoPointSlider.defaultProps, TwoPointSlider);

